import { render, staticRenderFns } from "./auctionBuying.vue?vue&type=template&id=0b5a548c&scoped=true"
import script from "./auctionBuying.vue?vue&type=script&lang=js"
export * from "./auctionBuying.vue?vue&type=script&lang=js"
import style0 from "./auctionBuying.vue?vue&type=style&index=0&id=0b5a548c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a548c",
  null
  
)

export default component.exports